import axios from 'axios';


export const login = user => {
	console.log(process.env.REACT_APP_API+'/api/login');
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/login',
          data: {
            email: user.email,
	      	password: user.password
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {
	      	localStorage.setItem('usertoken', response.data);
	      	return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	      	if(typeof err.response.status != undefined){
	      		if(err.response.status === 429){
	      			user.return_code = 429;
	      	}
	      	if(err.response.status === 400){
	      			user.return_code = 400;
	      	}
	      	if(err.response.status === 401){
	      			user.return_code = 401;
	      	}
	      	}	
	    })
}

export const post_user = user => {
	
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/users/',
          data: {
            first_name: user.first_name,
    		last_name: user.last_name,
    		email:user.email,
			password:user.password
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);  	
	    })
}



export const put_user = user => {
	
	return axios({
          method: 'put',
          url: process.env.REACT_APP_API+'/api/users/'+user.id,
          data: {
            id: user.id,
            email: user.email,
            password: user.password,
            first_name: user.firt_name,
			last_name: user.last_name
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);      	
	    })
}

export const delete_user = id => {
	
	return axios({
          method: 'delete',
          url: process.env.REACT_APP_API+'/api/users/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_user = id => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/users/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_users = () => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/users/',
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);      	
	    })
}

export const put_image = dataImg => {

	var bodyFormData = new FormData();
	bodyFormData.set('name', dataImg.name);
	bodyFormData.set('id_food', dataImg.id_food);
	bodyFormData.append('file', dataImg.selectedFile); 
	
	return axios({
          method: 'put',
          url: process.env.REACT_APP_API+'/api/images/'+dataImg.id,
          data:bodyFormData,
          headers: {'Content-Type': 'multipart/form-data' },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const display_image = name => {
	
	return axios({
         method: 'get',
         url:process.env.REACT_APP_API+'/api/display/'+name,
         auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }})
	    .then(response => {
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	      	
	    })


}


export const post_image = dataImg => {

	var bodyFormData = new FormData();
	bodyFormData.set('name', dataImg.name);
	bodyFormData.set('id_food', dataImg.id_food);
	bodyFormData.append('file', dataImg.selectedFile); 
	
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/images/',
          data:bodyFormData,
          headers: {'Content-Type': 'multipart/form-data' },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	    })
}

export const delete_image = id => {
	
	return axios({
          method: 'delete',
          url: process.env.REACT_APP_API+'/api/images/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err); 	
	    })
}

export const get_image = id => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/images/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_images = () => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/images/',
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	    })
}


export const put_food = dataFood => {
	
	return axios({
          method: 'put',
          url: process.env.REACT_APP_API+'/api/food/'+dataFood.id,
          data: {
            id_category: dataFood.id_category,
    		name: dataFood.name,
			description: dataFood.description,
			is_active: dataFood.is_active,
			is_emphased: dataFood.is_emphased,
    		price: dataFood.price,
			sortList: dataFood.sortList
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}


export const post_food = dataFood => {
	
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/food/',
          data: {
            id_category: dataFood.id_category,
    		name: dataFood.name,
			description: dataFood.description,
			is_active: dataFood.is_active,
			is_emphased: dataFood.is_emphased,
    		price: dataFood.price,
			sortList: dataFood.sortList
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const delete_food = id => {
	
	return axios({
          method: 'delete',
          url: process.env.REACT_APP_API+'/api/food/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err); 	
	    })
}

export const get_food = id => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/food/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_foods = () => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/food/',
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	    })
}



export const put_allergen = dataAllergen => {
	
	return axios({
          method: 'put',
          url: process.env.REACT_APP_API+'/api/allergen/'+dataAllergen.id,
          data: {
            id_food: dataAllergen.id_food,
    		name: dataAllergen.name
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}


export const post_allergen = dataAllergen => {
	
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/allergen/',
          data: {
            id_food: dataAllergen.id_food,
    		name: dataAllergen.name
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const delete_allergen = id => {
	
	return axios({
          method: 'delete',
          url: process.env.REACT_APP_API+'/api/allergen/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err); 	
	    })
}

export const get_allergen = id => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/allergen/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_allergens = () => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/allergen/',
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	    })
}

export const put_category = dataCategory => {
	
	return axios({
          method: 'put',
          url: process.env.REACT_APP_API+'/api/categories/'+dataCategory.id,
          data: {
    		name: dataCategory.name,
			sortList: dataCategory.sortList
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}


export const post_category = dataCategory => {
	
	return axios({
          method: 'post',
          url: process.env.REACT_APP_API+'/api/categories/',
          data: {
    		name: dataCategory.name,
			sortList: dataCategory.sortList
          },
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const delete_category = id => {
	
	return axios({
          method: 'delete',
          url: process.env.REACT_APP_API+'/api/categories/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          },
        })
	    .then(response => {  
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err); 	
	    })
}

export const get_category = id => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/categories/'+id,
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);	
	    })
}

export const get_categories = () => {
	
	return axios({
          method: 'get',
          url: process.env.REACT_APP_API+'/api/categories/',
          auth: {
            username: process.env.REACT_APP_ID,
	    	password: process.env.REACT_APP_MDP
          }, })
	    .then(response => {
	      
	      return response.data;
	    })
	    .catch(err => {
	      	console.log(err);
	    })
}


// WEBPACK FOOTER //
// ./src/api/UserFunctions.js